import RespondentDashboard from './RespondentDashboard';

export default RespondentDashboard;